import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// URL temporária do PDF assinado. O arquivo precisa ser entregue exatamente como foi assinado.
export function useSignedAttestedDocument() {
  const [isLoading, setLoading] = useState(false);

  const fetchUrl = useCallback((patientId, attestedId) => {
    setLoading(true);
    return quarkusApi
      .get(`/atestado/${patientId}/${attestedId}/signed-document`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setLoading(false));
  }, []);

  return { fetchUrl, isLoading };
}
